import { forwardRef } from "react";
import { FormControl, FormErrorMessage, Input, InputGroup, InputLeftAddon } from "@chakra-ui/react";
import { getObjValueFromPath, nonNumericSymbols } from "utils";
import EsgFormLabel from "./EsgFormLabel";

function NumericFormInputGroup(
  { label, labelFontSize = "sm", name, id = name, errors, controlProps, maxInlineSize, addonText, ...rest },
  ref
) {
  const error = getObjValueFromPath(name, errors);
  return (
    <FormControl
      isInvalid={error}
      maxInlineSize={maxInlineSize ? maxInlineSize : { base: "full", lg: "xs" }}
      minInlineSize="0"
      {...controlProps}
    >
      {label && (
        <EsgFormLabel
          htmlFor={id}
          fontWeight="bold"
          fontSize={labelFontSize}
        >
          {label}
        </EsgFormLabel>
      )}
      <InputGroup>
        {addonText && <InputLeftAddon children={addonText} fontWeight="semibold" />}
        <Input
          id={id} name={name} borderRadius="none" type="number" step='0.001'
          onWheel={e => e.target.blur()} {...rest} ref={ref}
          onKeyDown={(e) => nonNumericSymbols.includes(e.key) && e.preventDefault()}
        />
      </InputGroup>
      {error && <FormErrorMessage>{error?.message}</FormErrorMessage>}
    </FormControl>
  );
}

export default forwardRef(NumericFormInputGroup);
